var map = {
	"./de_DE.json": [
		4853,
		853
	],
	"./en_US.json": [
		6358,
		358
	],
	"./es_ES.json": [
		3639,
		639
	],
	"./fr_FR.json": [
		7659,
		659
	],
	"./it_IT.json": [
		7225,
		225
	],
	"./ja_JP.json": [
		3026,
		26
	],
	"./ko_KR.json": [
		4652,
		652
	],
	"./pt_BR.json": [
		6611,
		611
	],
	"./zh_CN.json": [
		3948,
		948
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5079;
module.exports = webpackAsyncContext;